.se-container-wide {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  padding-left: 15px;
  padding-right: 15px;
}

@media screen and (min-width: 980px) {
  .se-container-wide {
    padding-left: 10px;
    padding-right: 10px;
  }
}

.hmc-banner-container {
  display: block;
  margin: 0 auto;
  padding: 0 16px 20px;
  box-sizing: border-box;
  max-width: 1200px;
  overflow: visible;
  color: #626469;
  margin-top: 42px;
  padding-bottom: 0;
}

.hmc-banner-container *,
.hmc-banner-container *::before,
.hmc-banner-container *::after {
  box-sizing: inherit;
}

@media screen and (min-width: 980px) {
  .hmc-banner-container {
    padding: 0 10px;
  }
}

@media screen and (min-width: 980px) {
  .hmc-banner-container {
    margin-top: 48px;
  }
}

.subcategories__main {
  background-color: #fafafa;
}